import ListLeaveTerritory from "./ListLeaveTerritory";
export default ListLeaveTerritory;
